export const SAMPLE_CATEGORIES = [
  "Business Laptops",
  "Gaming Laptops",
  "Student Laptops",
  "Creator Laptops",
  "Ultrabooks",
  "Workstations",
];

export const SAMPLE_PRODUCTS = [
  {
    product_id: "prod-dell-lat-5410",
    model_name: "Dell Latitude 5410",
    brand_name: "Dell",
    category: "Business Laptops",
    price: 28999,
    mrp: 46999,
    ram: "8 GB",
    processor: "Intel Core i5",
    generation: "10th Gen",
    storage: "256 GB SSD",
    screen_size: "14 inch",
    in_stock: true,
    total_sales: 72,
    is_featured: true,
    images: ["/image/slide1A.jpg", "/image/slide1B.jpg"],
    detailedSpecs: {
      display: "14-inch FHD Anti-Glare",
      graphics: "Intel UHD Graphics",
      operating_system: "Windows 11 Pro",
      weight: "1.48 kg",
      battery: "4-Cell, up to 8 hours",
      keyboard: "Backlit Keyboard",
      ports: "USB-C, HDMI, 3xUSB-A",
      color: "Black",
    },
  },
  {
    product_id: "prod-hp-elitebook-840-g7",
    model_name: "HP EliteBook 840 G7",
    brand_name: "HP",
    category: "Business Laptops",
    price: 35999,
    mrp: 57999,
    ram: "16 GB",
    processor: "Intel Core i7",
    generation: "10th Gen",
    storage: "512 GB SSD",
    screen_size: "14 inch",
    in_stock: true,
    total_sales: 65,
    is_featured: true,
    images: ["/image/slide2A.jpg", "/image/slide2B.jpg"],
    detailedSpecs: {
      display: "14-inch FHD IPS",
      graphics: "Intel Iris Xe",
      operating_system: "Windows 11 Pro",
      weight: "1.35 kg",
      battery: "Long-life battery",
      keyboard: "Spill-resistant keyboard",
      ports: "Thunderbolt, HDMI, USB-A",
      color: "Silver",
    },
  },
  {
    product_id: "prod-lenovo-thinkpad-e14",
    model_name: "Lenovo ThinkPad E14",
    brand_name: "Lenovo",
    category: "Business Laptops",
    price: 32999,
    mrp: 51999,
    ram: "16 GB",
    processor: "Intel Core i5",
    generation: "11th Gen",
    storage: "512 GB SSD",
    screen_size: "14 inch",
    in_stock: true,
    total_sales: 59,
    is_featured: true,
    images: ["/image/slide3A.jpg", "/image/slide3B.jpg"],
    detailedSpecs: {
      display: "14-inch Full HD",
      graphics: "Intel Iris Xe",
      operating_system: "Windows 11 Home",
      weight: "1.64 kg",
      battery: "Up to 10 hours",
      keyboard: "ThinkPad Keyboard",
      ports: "USB-C, HDMI, Ethernet",
      color: "Black",
    },
  },
  {
    product_id: "prod-apple-macbook-air-m1",
    model_name: "Apple MacBook Air M1",
    brand_name: "Apple",
    category: "Ultrabooks",
    price: 58999,
    mrp: 79999,
    ram: "8 GB",
    processor: "Apple M1",
    generation: "13th Gen",
    storage: "256 GB SSD",
    screen_size: "13.3 inch",
    in_stock: true,
    total_sales: 104,
    is_featured: true,
    images: ["/image/slide4A.jpg", "/image/slide4B.jpg"],
    detailedSpecs: {
      display: "Retina Display",
      graphics: "Apple Integrated GPU",
      operating_system: "macOS",
      weight: "1.29 kg",
      battery: "Up to 15 hours",
      keyboard: "Magic Keyboard",
      ports: "2x Thunderbolt / USB 4",
      color: "Space Gray",
    },
  },
  {
    product_id: "prod-asus-rog-strix-g15",
    model_name: "ASUS ROG Strix G15",
    brand_name: "ASUS",
    category: "Gaming Laptops",
    price: 64999,
    mrp: 89999,
    ram: "16 GB",
    processor: "AMD Ryzen 7",
    generation: "12th Gen",
    storage: "1 TB SSD",
    screen_size: "15.6 inch",
    in_stock: true,
    total_sales: 51,
    is_featured: true,
    images: ["/image/slide5A.jpg", "/image/slide5B.jpg"],
    detailedSpecs: {
      display: "15.6-inch 144Hz",
      graphics: "NVIDIA RTX 3050",
      operating_system: "Windows 11",
      weight: "2.3 kg",
      battery: "56Wh battery",
      keyboard: "RGB keyboard",
      ports: "USB-C, HDMI, LAN",
      color: "Eclipse Gray",
    },
  },
  {
    product_id: "prod-acer-nitro-5",
    model_name: "Acer Nitro 5",
    brand_name: "Acer",
    category: "Gaming Laptops",
    price: 54999,
    mrp: 76999,
    ram: "16 GB",
    processor: "Intel Core i5",
    generation: "12th Gen",
    storage: "512 GB SSD",
    screen_size: "15.6 inch",
    in_stock: false,
    total_sales: 38,
    is_featured: false,
    images: ["/image/home1.jpg", "/image/home2.jpg"],
    detailedSpecs: {
      display: "15.6-inch FHD 144Hz",
      graphics: "NVIDIA GTX 1650",
      operating_system: "Windows 11",
      weight: "2.2 kg",
      battery: "57Wh battery",
      keyboard: "Backlit Keyboard",
      ports: "USB-C, HDMI, USB-A",
      color: "Black/Red",
    },
  },
  {
    product_id: "prod-hp-pavilion-15",
    model_name: "HP Pavilion 15",
    brand_name: "HP",
    category: "Student Laptops",
    price: 41999,
    mrp: 60999,
    ram: "8 GB",
    processor: "Intel Core i5",
    generation: "11th Gen",
    storage: "512 GB SSD",
    screen_size: "15.6 inch",
    in_stock: true,
    total_sales: 44,
    is_featured: false,
    images: ["/image/land1.jpg"],
    detailedSpecs: {
      display: "15.6-inch FHD IPS",
      graphics: "Intel Iris Xe",
      operating_system: "Windows 11 Home",
      weight: "1.75 kg",
      battery: "8 hours backup",
      keyboard: "Full-size keyboard",
      ports: "USB-C, HDMI, SD card",
      color: "Natural Silver",
    },
  },
  {
    product_id: "prod-dell-inspiron-3520",
    model_name: "Dell Inspiron 3520",
    brand_name: "Dell",
    category: "Student Laptops",
    price: 38999,
    mrp: 54999,
    ram: "8 GB",
    processor: "Intel Core i3",
    generation: "12th Gen",
    storage: "512 GB SSD",
    screen_size: "15.6 inch",
    in_stock: true,
    total_sales: 33,
    is_featured: false,
    images: ["/image/land2.jpg"],
    detailedSpecs: {
      display: "15.6-inch FHD",
      graphics: "Intel UHD Graphics",
      operating_system: "Windows 11",
      weight: "1.9 kg",
      battery: "4-cell battery",
      keyboard: "Standard keyboard",
      ports: "USB, HDMI, Audio Jack",
      color: "Platinum Silver",
    },
  },
  {
    product_id: "prod-lenovo-ideapad-slim-3",
    model_name: "Lenovo IdeaPad Slim 3",
    brand_name: "Lenovo",
    category: "Student Laptops",
    price: 33999,
    mrp: 48999,
    ram: "8 GB",
    processor: "AMD Ryzen 5",
    generation: "11th Gen",
    storage: "512 GB SSD",
    screen_size: "15.6 inch",
    in_stock: true,
    total_sales: 57,
    is_featured: false,
    images: ["/image/land3.jpg"],
    detailedSpecs: {
      display: "15.6-inch Full HD",
      graphics: "AMD Radeon Graphics",
      operating_system: "Windows 11",
      weight: "1.65 kg",
      battery: "Up to 9 hours",
      keyboard: "Ergonomic keyboard",
      ports: "USB-C, HDMI, USB 3.0",
      color: "Arctic Grey",
    },
  },
  {
    product_id: "prod-apple-macbook-pro-m2",
    model_name: "Apple MacBook Pro M2",
    brand_name: "Apple",
    category: "Creator Laptops",
    price: 94999,
    mrp: 129999,
    ram: "16 GB",
    processor: "Apple M2",
    generation: "14th Gen",
    storage: "512 GB SSD",
    screen_size: "13.6 inch",
    in_stock: true,
    total_sales: 47,
    is_featured: true,
    images: ["/image/land4.jpg"],
    detailedSpecs: {
      display: "Liquid Retina",
      graphics: "Integrated 10-core GPU",
      operating_system: "macOS",
      weight: "1.4 kg",
      battery: "Up to 18 hours",
      keyboard: "Magic Keyboard",
      ports: "Thunderbolt, MagSafe",
      color: "Space Gray",
    },
  },
  {
    product_id: "prod-asus-vivobook-14",
    model_name: "ASUS Vivobook 14",
    brand_name: "ASUS",
    category: "Ultrabooks",
    price: 36999,
    mrp: 52999,
    ram: "8 GB",
    processor: "Intel Core i5",
    generation: "11th Gen",
    storage: "512 GB SSD",
    screen_size: "14 inch",
    in_stock: true,
    total_sales: 29,
    is_featured: false,
    images: ["/image/land5.jpg"],
    detailedSpecs: {
      display: "14-inch FHD NanoEdge",
      graphics: "Intel Iris Xe",
      operating_system: "Windows 11",
      weight: "1.6 kg",
      battery: "37Wh battery",
      keyboard: "Chiclet Keyboard",
      ports: "USB-C, HDMI, USB-A",
      color: "Indie Black",
    },
  },
  {
    product_id: "prod-acer-swift-3",
    model_name: "Acer Swift 3",
    brand_name: "Acer",
    category: "Ultrabooks",
    price: 43999,
    mrp: 62999,
    ram: "16 GB",
    processor: "AMD Ryzen 7",
    generation: "12th Gen",
    storage: "512 GB SSD",
    screen_size: "14 inch",
    in_stock: true,
    total_sales: 34,
    is_featured: false,
    images: ["/image/home3.jpg"],
    detailedSpecs: {
      display: "14-inch IPS",
      graphics: "AMD Radeon Graphics",
      operating_system: "Windows 11",
      weight: "1.2 kg",
      battery: "Up to 12 hours",
      keyboard: "Backlit keyboard",
      ports: "USB-C, HDMI, USB-A",
      color: "Silver",
    },
  },
  {
    product_id: "prod-dell-xps-13",
    model_name: "Dell XPS 13",
    brand_name: "Dell",
    category: "Creator Laptops",
    price: 75999,
    mrp: 104999,
    ram: "16 GB",
    processor: "Intel Core i7",
    generation: "13th Gen",
    storage: "1 TB SSD",
    screen_size: "13.4 inch",
    in_stock: true,
    total_sales: 22,
    is_featured: true,
    images: ["/image/home4.jpg"],
    detailedSpecs: {
      display: "InfinityEdge Display",
      graphics: "Intel Iris Xe",
      operating_system: "Windows 11 Pro",
      weight: "1.2 kg",
      battery: "12 hours backup",
      keyboard: "Edge-to-edge keyboard",
      ports: "Thunderbolt 4",
      color: "Platinum",
    },
  },
  {
    product_id: "prod-hp-zbook-firefly",
    model_name: "HP ZBook Firefly",
    brand_name: "HP",
    category: "Workstations",
    price: 82999,
    mrp: 119999,
    ram: "32 GB",
    processor: "Intel Core i7",
    generation: "12th Gen",
    storage: "1 TB SSD",
    screen_size: "15.6 inch",
    in_stock: true,
    total_sales: 18,
    is_featured: false,
    images: ["/image/slide1A.jpg"],
    detailedSpecs: {
      display: "15.6-inch DreamColor",
      graphics: "NVIDIA T500",
      operating_system: "Windows 11 Pro",
      weight: "1.9 kg",
      battery: "Long battery",
      keyboard: "Backlit spill-resistant",
      ports: "USB-C, HDMI, LAN",
      color: "Silver",
    },
  },
  {
    product_id: "prod-lenovo-legion-5",
    model_name: "Lenovo Legion 5",
    brand_name: "Lenovo",
    category: "Gaming Laptops",
    price: 68999,
    mrp: 95999,
    ram: "16 GB",
    processor: "AMD Ryzen 7",
    generation: "13th Gen",
    storage: "1 TB SSD",
    screen_size: "15.6 inch",
    in_stock: true,
    total_sales: 40,
    is_featured: true,
    images: ["/image/slide2A.jpg"],
    detailedSpecs: {
      display: "15.6-inch 165Hz",
      graphics: "NVIDIA RTX 3060",
      operating_system: "Windows 11",
      weight: "2.4 kg",
      battery: "80Wh battery",
      keyboard: "RGB gaming keyboard",
      ports: "USB-C, HDMI, LAN, USB-A",
      color: "Phantom Blue",
    },
  },
  {
    product_id: "prod-samsung-galaxy-book2",
    model_name: "Samsung Galaxy Book2",
    brand_name: "Samsung",
    category: "Ultrabooks",
    price: 46999,
    mrp: 68999,
    ram: "8 GB",
    processor: "Intel Core i5",
    generation: "12th Gen",
    storage: "512 GB SSD",
    screen_size: "15.6 inch",
    in_stock: true,
    total_sales: 14,
    is_featured: false,
    images: ["/image/slide3A.jpg"],
    detailedSpecs: {
      display: "15.6-inch AMOLED",
      graphics: "Intel Iris Xe",
      operating_system: "Windows 11",
      weight: "1.57 kg",
      battery: "54Wh battery",
      keyboard: "Backlit keyboard",
      ports: "USB-C, HDMI, USB-A",
      color: "Graphite",
    },
  },
  {
    product_id: "prod-msi-modern-15",
    model_name: "MSI Modern 15",
    brand_name: "MSI",
    category: "Creator Laptops",
    price: 49999,
    mrp: 72999,
    ram: "16 GB",
    processor: "Intel Core i7",
    generation: "11th Gen",
    storage: "512 GB SSD",
    screen_size: "15.6 inch",
    in_stock: false,
    total_sales: 12,
    is_featured: false,
    images: ["/image/slide4A.jpg"],
    detailedSpecs: {
      display: "IPS-Level Display",
      graphics: "Intel Iris Xe",
      operating_system: "Windows 11",
      weight: "1.6 kg",
      battery: "39Wh battery",
      keyboard: "White backlit keyboard",
      ports: "USB-C, HDMI, USB-A",
      color: "Classic Black",
    },
  },
];

